import {
  UnorderedListOutlined,
  LogoutOutlined,
  CalendarOutlined,
  TagsOutlined,
  PlayCircleOutlined,
  NotificationOutlined,
  AppstoreOutlined,
  FileImageOutlined,
  UserOutlined,
  GlobalOutlined,
  ShopOutlined,
  QuestionCircleOutlined,
  WarningOutlined,
  TrophyOutlined,
  TeamOutlined,
  ReconciliationOutlined,
  TwitterOutlined,
  FrownOutlined,
  DashboardOutlined,
  SkinOutlined,
  BarcodeOutlined,
  DribbbleOutlined,

} from '@ant-design/icons'
import { Menu, Layout, Image } from 'antd'
import { useState, useMemo, useContext } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { deleteToken } from 'src/utils/accessToken'
import AppContext from 'src/hooks/AppContext'
import logo from 'src/assets/images/exscapelogo.svg'
const { Sider } = Layout
import { fetchUserInfo } from 'src/api/authen'

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(true)
  const location = useLocation()
  const navigate = useNavigate()
  const { userInfo } = useContext(AppContext)

  const getSelected = () => {
    const [, pathname] = location.pathname.split('/')
    return `/${pathname}`
  }

  const onLogout = () => {
    deleteToken()
    navigate('/login')
  }

  const naviagateBaseonPerm = async () => {
    const userInfo = await fetchUserInfo()
    if (userInfo?.data.permissions.includes('event-view')) {
      navigate('/events/maf')
    } else if (
      userInfo?.data.permissions.includes('music') ||
      userInfo?.data.permissions.includes('game-content')
    ) {
      navigate('/welcome')
    } else {
      navigate('/dashboard')
    }
  }

  const items = useMemo(() => {
    const allItems = [
      {
        key: '/dashboard',
        icon: <DashboardOutlined />,
        label: <Link to="">Dashboard</Link>,
        visible: true,
        requiredprivileges: [
          'reports',
          'finance',
          'moderator',
          'support',
          'marketing',
          'superadmin',

          'marketplace',
        ],
        children: [
          {
            key: '/dashboard',
            icon: <UnorderedListOutlined />,
            label: <Link to="/dashboard">User</Link>,
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/dashboard/social',
            icon: <UnorderedListOutlined />,
            label: <Link to="/dashboard/social">Social</Link>,
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/dashboard/avatar',
            icon: <UnorderedListOutlined />,
            label: <Link to="/dashboard/avatar">Avatar</Link>,
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/dashboard/redeem',
            icon: <UnorderedListOutlined />,
            label: <Link to="/dashboard/redeem">Redeem</Link>,
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
        ],
      },
      {
        key: '/discovery',
        icon: <AppstoreOutlined />,
        label: 'Discovery',
        requiredprivileges: ['marketing', 'moderator', 'superadmin', 'music'],
        visible: true,
        children: [
          {
            key: '/discovery/main-discovery',
            icon: <UnorderedListOutlined />,
            label: <Link to="/discovery/main-discovery">Main</Link>,
            requiredprivileges: ['marketing', 'moderator', 'superadmin'],
          },
          {
            key: '/discovery/playlist-discovery',
            icon: <UnorderedListOutlined />,
            label: <Link to="/discovery/playlist-discovery">Playlists</Link>,
            requiredprivileges: [
              'marketing',
              'moderator',
              'music',
              'superadmin',
            ],
          },
          {
            key: '/discovery/tracks-discovery',
            icon: <UnorderedListOutlined />,
            label: <Link to="/discovery/tracks-discovery">Tracks</Link>,
            requiredprivileges: [
              'marketing',
              'moderator',
              'music',
              'superadmin',
            ],
          },
          {
            key: '/discovery/stations-discovery',
            icon: <UnorderedListOutlined />,
            label: <Link to="/discovery/stations-discovery">Stations</Link>,
            requiredprivileges: [
              'marketing',
              'moderator',
              'music',
              'superadmin',
            ],
          },
          {
            key: '/discovery/games-discovery',
            icon: <UnorderedListOutlined />,
            label: <Link to="/discovery/games-discovery">Games</Link>,
            requiredprivileges: ['marketing', 'moderator', 'superadmin'],
            visible: false,
          },
          {
            key: '/discovery/metaverse-discovery',
            icon: <UnorderedListOutlined />,
            label: <Link to="/discovery/metaverse-discovery">Metaverse</Link>,
            requiredprivileges: [
              'marketing',
              'moderator',
              'superadmin',
              'game-content',
            ],
            visible: false,
          },
          {
            key: '/discovery/maze-discovery',
            icon: <UnorderedListOutlined />,
            label: <Link to="/discovery/maze-discovery">Maze</Link>,
            requiredprivileges: ['marketing', 'moderator', 'superadmin'],
            visible: false,
          },
          {
            key: '/discovery/layout',
            icon: <UnorderedListOutlined />,
            label: <Link to="/discovery/layout">Layout</Link>,
            requiredprivileges: ['marketing', 'moderator', 'superadmin'],
          },
        ],
      },
      {
        key: '/leaderboard',
        icon: <TrophyOutlined />,
        label: 'Leaderboard',
        requiredprivileges: [
          'finance',
          'support',
          'marketing',
          'moderator',
          'superadmin',
        ],
        children: [
          {
            key: '/leaderboard/treasure-hunter',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/leaderboard/treasure-hunter">Treasure Hunter</Link>
            ),
            requiredprivileges: [
              'finance',
              'support',
              'marketing',
              'moderator',
              'superadmin',
            ],
          },
          {
            key: '/leaderboard/maze',
            icon: <UnorderedListOutlined />,
            label: <Link to="/leaderboard/maze">Maze</Link>,
            requiredprivileges: [
              'finance',
              'support',
              'marketing',
              'moderator',
              'superadmin',
            ],
          },
          {
            key: '/leaderboard/game',
            icon: <UnorderedListOutlined />,
            label: <Link to="/leaderboard/game">Game</Link>,
            requiredprivileges: [
              'finance',
              'support',
              'marketing',
              'moderator',
              'superadmin',
            ],
          },
          {
            key: '/leaderboard/monthly/winners',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/leaderboard/monthly/winners">Monthly Winners</Link>
            ),
            requiredprivileges: [
              'finance',
              'support',
              'marketing',
              'moderator',
              'superadmin',
            ],
          },
          {
            key: '/leaderboard/survival-zone',
            icon: <UnorderedListOutlined />,
            label: <Link to="/leaderboard/survival-zone">Survival Zone</Link>,
            requiredprivileges: [
              'finance',
              'support',
              'marketing',
              'moderator',
              'superadmin',
            ],
          },
        ],
      },
      {
        key: '/playlist',
        icon: <UnorderedListOutlined />,
        label: <Link to="/playlist">Playlist</Link>,
        requiredprivileges: ['music', 'superadmin'],
      },
      {
        key: '/metaverse',
        icon: <GlobalOutlined />,
        label: <Link to="/metaverse">Metaverse</Link>,
        requiredprivileges: ['marketing', 'game-content', 'superadmin'],
      },
      {
        key: '/characters',
        icon: <SkinOutlined />,
        label: 'Characters',
        requiredprivileges: ['marketing', 'game-content', 'superadmin'],
        children: [
          {
            key: '/characters/main',
            icon: <UnorderedListOutlined />,
            label: <Link to="/characters/main">All</Link>,
            requiredprivileges: ['marketing', 'game-content', 'superadmin'],
          },
          {
            key: '/characters/layout',
            icon: <UnorderedListOutlined />,
            label: <Link to="/characters/layout">Layout</Link>,
            requiredprivileges: ['marketing', 'game-content', 'superadmin'],
          },
        ],
      },

      {
        key: '/games',
        icon: <DribbbleOutlined />,
        label: <Link to="/AllGames">All Games</Link>,
        requiredprivileges: [
          'game-content',
          'moderator',
          'marketing',
          'superadmin',
        ],
      },
      {
        key: '/arena',
        icon: <TrophyOutlined />,
        label: 'Arena',
        requiredprivileges: ['arena-content', 'marketing', 'superadmin'],
        children: [
          {
            key: '/arena/games',
            icon: <UnorderedListOutlined />,
            label: <Link to="/arena/games">Games</Link>,
            requiredprivileges: ['arena-content', 'marketing', 'superadmin'],
          },
          {
            key: '/arena/tournaments',
            icon: <UnorderedListOutlined />,
            label: <Link to="/arena/tournaments">Tournaments</Link>,
            requiredprivileges: ['arena-content','marketing', 'superadmin'],
          },
          {
            key: '/arena/daily-challenges',
            icon: <UnorderedListOutlined />,
            label: <Link to="/arena/daily-challenges">Daily Challenges</Link>,
            requiredprivileges: ['arena-content','marketing', 'superadmin'],
          },
        ],
      },
      {
        key: '/marketplace',
        icon: <ShopOutlined />,
        label: <Link to="/marketplace">Marketplace</Link>,
        requiredprivileges: ['marketplace', 'superadmin'],
      },

      {
        key: '/faq',
        icon: <QuestionCircleOutlined />,
        label: <Link to="/faq">Faq</Link>,
        requiredprivileges: ['game-content', 'marketing', 'superadmin'],
      },
      {
        key: '/abuse',
        icon: <WarningOutlined />,
        label: <Link to="/abuse">Abuse</Link>,
        requiredprivileges: ['game-content', 'superadmin'],
      },
      {
        key: '/track',
        icon: <PlayCircleOutlined />,
        label: <Link to="/track">Track</Link>,
        requiredprivileges: ['music', 'superadmin'],
      },
      {
        key: '/station',
        icon: <NotificationOutlined />,
        label: <Link to="/station">Station</Link>,
        requiredprivileges: ['music', 'superadmin'],
      },
      {
        key: '/tags',
        icon: <TagsOutlined />,
        label: 'Tags',
        requiredprivileges: [
          'game-content',
          'support',
          'marketing',
          'music',
          'superadmin',
        ],
        children: [
          {
            key: '/tags/music',
            icon: <UnorderedListOutlined />,
            label: <Link to="/tags/music">Music</Link>,
            requiredprivileges: ['support', 'marketing', 'music', 'superadmin'],
          },
          {
            key: '/tags/games',
            icon: <UnorderedListOutlined />,
            label: <Link to="/tags/games">Games</Link>,
            requiredprivileges: [
              'game-content',
              'support',
              'marketing',
              'superadmin',
            ],
          },
        ],
      },
      {
        key: '/image',
        icon: <FileImageOutlined />,
        label: 'Image',
        requiredprivileges: ['music', 'superadmin'],
        children: [
          {
            key: '/image/playlist',
            icon: <UnorderedListOutlined />,
            label: <Link to="/image/playlist">Playlist</Link>,
            requiredprivileges: ['music', 'superadmin'],
          },
        ],
      },
      {
        key: '/users',
        icon: <UserOutlined />,
        label: 'Users',
        requiredprivileges: [
          'finance',
          'support',
          'moderator',
          'superadmin',
          'marketplace',
        ],
        children: [
          {
            key: '/users/users',
            icon: <UnorderedListOutlined />,
            label: <Link to="/users/users">Users</Link>,
            requiredprivileges: [
              'finance',
              'support',
              'superadmin',
              'marketplace',
              'moderator',
            ],
          },
          {
            key: '/users/redeemUsers',
            icon: <UnorderedListOutlined />,
            label: <Link to="/users/redeemUsers">Redeem Users</Link>,
            requiredprivileges: [
              'finance',
              'support',
              'moderator',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/users/loggedInUsers',
            icon: <UnorderedListOutlined />,
            label: <Link to="/users/loggedInUsers">LoggedIn Users</Link>,
            requiredprivileges: [
              'finance',
              'support',
              'superadmin',
              'marketplace',
              'moderator',
            ],
          },
          {
            key: '/users/delete',
            icon: <UnorderedListOutlined />,
            label: <Link to="/users/delete">Deleted Users</Link>,
            requiredprivileges: [
              'finance',
              'support',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/users/journey',
            icon: <UnorderedListOutlined />,
            label: <Link to="/users/journey">User Journey</Link>,
            requiredprivileges: [
              'finance',
              'support',
              'superadmin',
              'marketplace',
            ],
          },
        ],
      },
      {
        key: '/cheaters',
        icon: <FrownOutlined />,
        label: 'Cheaters',

        requiredprivileges: ['moderator', 'superadmin'],

        children: [
          {
            key: '/cheaters/access-token',
            icon: <UnorderedListOutlined />,
            label: <Link to="/cheaters/access-token">Access Token</Link>,
            requiredprivileges: ['moderator', 'superadmin'],
          },
          {
            key: '/cheaters/games-anomaly',
            icon: <UnorderedListOutlined />,
            label: <Link to="/cheaters/games-anomaly">Games Anomaly</Link>,

            requiredprivileges: ['moderator', 'superadmin'],
          },
          {
            key: '/cheaters/treasure-anomaly',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/cheaters/treasure-anomaly">Treasure Anomaly</Link>
            ),
            requiredprivileges: ['moderator', 'superadmin'],
          },
        ],
      },
      {
        key: '/audit',
        icon: <ReconciliationOutlined />,
        label: <Link to="/audit">Audit</Link>,
        requiredprivileges: ['superadmin'],
      },
      {
        key: '/social',
        icon: <TwitterOutlined />,
        label: 'Social',
        requiredprivileges: ['marketing', 'moderator', 'superadmin'],
        children: [
          {
            key: '/social/post',
            icon: <UnorderedListOutlined />,
            label: <Link to="/social/post">Post</Link>,
            requiredprivileges: ['marketing', 'moderator', 'superadmin'],
          },
          {
            key: '/social/bots',
            icon: <UnorderedListOutlined />,
            label: <Link to="/social/bots">Bots</Link>,
            requiredprivileges: ['marketing', 'moderator', 'superadmin'],
          },
          {
            key: '/social/message',
            icon: <UnorderedListOutlined />,
            label: <Link to="/social/message">Message</Link>,
            requiredprivileges: ['marketing', 'moderator', 'superadmin'],
          },
          {
            key: '/social/bot-chats',
            icon: <UnorderedListOutlined />,
            label: <Link to="/social/bot-chats">Bot Chats</Link>,
            requiredprivileges: ['marketing', 'moderator', 'superadmin'],
          },
          {
            key: '/social/bot-posts',
            icon: <UnorderedListOutlined />,
            label: <Link to="/social/bot-posts">Bot Posts</Link>,
            requiredprivileges: ['marketing', 'moderator', 'superadmin'],
          },
          {
            key: '/social/user-posts',
            icon: <UnorderedListOutlined />,
            label: <Link to="/social/user-posts">User Posts</Link>,
            requiredprivileges: ['marketing', 'moderator', 'superadmin'],
          },

          {
            key: '/social/abuse-reason',
            icon: <UnorderedListOutlined />,
            label: <Link to="/social/abuse-reason">Abuse Reason</Link>,
            requiredprivileges: ['marketing', 'moderator', 'superadmin'],
          },
        ],
      },
      {
        key: '/access',
        icon: <TeamOutlined />,
        label: <Link to="/access">Access</Link>,
        requiredprivileges: ['superadmin'],
      },
      {
        key: '/redeem-codes',
        icon: <BarcodeOutlined />,
        label: <Link to="/redeem-codes">Redeem Codes</Link>,
        requiredprivileges: ['superadmin'],
      },
      {
        key: '/quiz',
        icon: <ReconciliationOutlined />,
        label: <Link to="/quiz">Quiz</Link>,
        requiredprivileges: ['marketing', 'game-content', 'superadmin'],
      },
      {
        key: '/reports',
        icon: <FileImageOutlined />,
        label: 'Report',
        requiredprivileges: [
          'reports',
          'finance',
          'support',
          'moderator',
          'marketing',
          'superadmin',
          'music',
          'marketplace',
        ],
        children: [
          {
            key: '/reports/playlist-reports',
            icon: <UnorderedListOutlined />,
            label: <Link to="/reports/playlist-reports">Playlists Report</Link>,
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'music',
              'marketplace',
            ],
          },
          {
            key: '/reports/station-reports',
            icon: <UnorderedListOutlined />,
            label: <Link to="/reports/station-reports">Stations Report</Link>,
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'music',
              'marketplace',
            ],
          },
          {
            key: '/reports/tracks-reports',
            icon: <UnorderedListOutlined />,
            label: <Link to="/reports/tracks-reports">Tracks Report</Link>,
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'music',
              'marketplace',
            ],
          },
          {
            key: '/reports/appUsage-reports',
            icon: <UnorderedListOutlined />,
            label: <Link to="/reports/appUsage-reports">App Usage Report</Link>,
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/metaverse-reports',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/metaverse-reports">Metaverse Report</Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/maze-reports',
            icon: <UnorderedListOutlined />,
            label: <Link to="/reports/maze-reports">Maze Report</Link>,
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/survivor-zone-report',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/survivor-zone-report">
                Survivor Zone Report
              </Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/usersSearch-reports',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/usersSearch-reports">Users Search Report</Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/userProfileChange-reports',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/userProfileChange-reports">
                Profile Change Report
              </Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/gameUsage-reports',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/gameUsage-reports">Game Usage Report</Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/user-points-reports',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/user-points-reports">User Points Report</Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/ads-reports',
            icon: <UnorderedListOutlined />,
            label: <Link to="/reports/ads-reports">Ads Report</Link>,
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/treasure-redeem-reports',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/treasure-redeem-reports">
                Treasure Redeem Report
              </Link>
            ),
            requiredprivileges: ['report', 'superadmin', 'marketplace'],
          },
          {
            key: '/reports/chatUsage-reports',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/chatUsage-reports">Chat Usage Report</Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/marketplace-usage-report',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/marketplace-usage-report">
                Marketplace Usage Report
              </Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/userprofile-usage-report',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/userprofile-usage-report">
                Userprofile Usage Report
              </Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/select-avatar-usage-report',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/select-avatar-usage-report">
                Select Avatar Usage Report
              </Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/create-avatar-usage-report',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/create-avatar-usage-report">
                Create Avatar Usage Report
              </Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/socialUsage-reports',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/socialUsage-reports">Social Usage Report</Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/treasureHunter-reports',
            icon: <UnorderedListOutlined />,
            label: (
              <Link to="/reports/treasureHunter-reports">
                Treasure Hunter Report
              </Link>
            ),
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
          {
            key: '/reports/avatar-reports',
            icon: <UnorderedListOutlined />,
            label: <Link to="/reports/avatar-reports">Avatar Report</Link>,
            requiredprivileges: [
              'reports',
              'finance',
              'support',
              'moderator',
              'marketing',
              'superadmin',
              'marketplace',
            ],
          },
        ],
      },
      {
        key: '/events',
        icon: <CalendarOutlined />,
        label: <Link to="/events">Event</Link>,
        requiredprivileges: ['marketing', 'game-content', 'superadmin'],
        children: [
          {
            key: '/events/prices',
            icon: <UnorderedListOutlined />,
            label: <Link to="/events/prices">Prices</Link>,
            requiredprivileges: ['marketing', 'game-content', 'superadmin'],
          },
          {
            key: '/events/maf',
            icon: <UnorderedListOutlined />,
            label: <Link to="/events/maf">QR Scanner</Link>,
            requiredprivileges: ['marketing', 'game-content', 'superadmin'],
          },
          {
            key: '/events/leaderboard',
            icon: <UnorderedListOutlined />,
            label: <Link to="/events/leaderboard">LeaderBoard</Link>,
            requiredprivileges: ['marketing', 'game-content', 'superadmin'],
          },
        ],
      },
      
      {
        key: '/logout',
        icon: <LogoutOutlined />,
        onClick: onLogout,
        label: 'Logout',
      },
      {},
    ]

    const filterItems = (items) => {
      return items
        .filter(
          (item) =>
            ((item.visible === undefined || item.visible === true) &&
              !item.requiredprivileges) ||
            (userInfo?.permissions &&
              item.requiredprivileges.some((privilege) =>
                userInfo.permissions.includes(privilege)
              ))
        )
        .map((item) => ({
          ...item,
          children: item.children
            ? filterItems(item.children).filter(
                (childItem) =>
                  childItem.visible === undefined || childItem.visible === true
              )
            : undefined,
        }))
    }
    return filterItems(allItems)
  }, [userInfo])

  return (
    <Sider
      className="site-sidebar"
      collapsible
      collapsed={collapsed}
      onCollapse={setCollapsed}
    >
      <div className="logo-wrap">
        <div className="logo-wrap">
          <div onClick={naviagateBaseonPerm} style={{ cursor: 'pointer' }}>
            <Image src={logo} preview={false} />
          </div>
        </div>
      </div>
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={[getSelected()]}
        items={items}
      />
    </Sider>
  )
}
